<template>
  <MultipleChoicesDropdown
    title="business type"
    :value="value"
    :show-clear-all="false"
    :single-choice="false"
    :search-enabled="false"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import BUSINESS_TYPES from '@/services/business-types'

export default {
  props: {
    value: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    choices: BUSINESS_TYPES,
  }),
  methods: {
    onChange(choices) {
      this.$emit('change', choices)
    },
  },
}
</script>
